module.exports = __webpack_public_path__ + "img/banner-home.5bed6f31.jpeg";